
@if (canRender()) {
  @let legendEnabled = customLegend.enabled();
  <div class="pbir-highcharts-wrapper {{wrapperClasses()}}"
       [style.--legend-font-size]="legendFontSize()"
       [style.--legend-text-color]="legendTextColor()"
       #wrapper>
    <pbir-highcharts-chart #highcharts
      [chartOptions]="chartOptions()"
      [plotOptions]="plotOptions()"
      [xAxis]="xAxis()"
      [yAxis]="yAxis()"
      [series]="series()"
      [tooltip]="tooltip()"
      [legend]="legendOptions()"
      [navigator]="navigatorOptions()"
      [colorAxis]="colorAxisOptions()">
    </pbir-highcharts-chart>

    @if (xAxisTitleEnabled()) {
      <div class="pbir-highcharts-xaxis-title" [style]="xAxisTitleStyle()" [class.pbir-highcharts-xaxis-title-horizontal]="isHorizontalPlot()">
        <span [title]="xAxisTitle()">{{xAxisTitle()}}</span>
      </div>
    }
  
    @if (legendEnabled) {
      <div class="pbir-highcharts-legend">
        <div class="legend-items-scroll" #legendScroll>
          <div class="legend-nav" (click)="customLegend.navClick(-1)">
            <i class="fas fa-caret-left legend-nav-h"></i>
            <i class="fas fa-caret-up legend-nav-v"></i>
          </div>
          <div class="legend-items" #legendItems>
            @for (item of customLegend.items(); track item.id) {
              <div class="legend-item"
                    [class.legend-item__selected]="item.selected()"
                    [class.legend-item__hidden]="!item.visible()"
                    [title]="item.name()"
                    (click)="customLegend.itemClick(item)">
                <span class="legend-item__symbol" [style.backgroundColor]="item.color()">
                </span>
                <span class="legend-item__text">
                  {{item.name()}}
                </span>
              </div>
            }
          </div>
          <div class="legend-nav" (click)="customLegend.navClick(+1)">
            <i class="fas fa-caret-right legend-nav-h"></i>
            <i class="fas fa-caret-down legend-nav-v"></i>
          </div>
        </div>
      </div>
    }
  </div>

  <ng-template #dataTooltipTemplate let-dataTooltip="dataTooltip">
    <pbir-datatooltip [dataTooltip]="dataTooltip"></pbir-datatooltip>
  </ng-template>
}